import { memo } from 'react';

import { useDelayedLoading } from '@/shared/lib/hooks/use-delayed-loading.hook';
import { Spinner } from '@/shared/ui/spinner';

import * as Styled from './page-loader.styles';

const PageLoaderComponent = () => {
	const isVisible = useDelayedLoading(true);

	if (!isVisible) {
		return null;
	}

	return (
		<Styled.Wrapper tag="main" align="center" justify="center" flex={1}>
			<Spinner />
		</Styled.Wrapper>
	);
};

export default memo(PageLoaderComponent);
